import { Box, Button, Container, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../core/hooks/useStore";
import { RootState } from "../../core/store/store";
import NotFoundIcon from "../error/illustration-not-found.svg";

const IntegrationsEmpty = (props: any) => {
  const dispatch = useAppDispatch();
  const { apiUrl } = useSelector((state: RootState) => state.home);
  const integrationData = useSelector((state: RootState) => state.integrations);

  return (
    <>
      <Container
        maxWidth="md"
        sx={{
          px: 5,
          py: 14,
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            "& img": {
              maxWidth: "100%",
            },
          }}
        ></Box>
        <img src={NotFoundIcon} alt="You Haven't Created an Integration Yet!" />
        <Typography align="center" variant="h3" sx={{ pt: 2 }}>
          You Haven't Created an Integration Yet!
        </Typography>
        <Typography align="center" color="text.secondary" variant="body2">
          Integrations allow you to automatically post content to your WordPress
          site. Click the create button now to create your first integration.
        </Typography>
        <Button onClick={props.dialog.handleOpen} sx={{ mt: 2 }}>
          Create an Integration
        </Button>
      </Container>
    </>
  );
};

export default IntegrationsEmpty;
